require('./pricingController');
require('../purchase/purchaseForm/purchaseFormDirective');
require('../purchase/teamSubscriptionPurchaseForm/teamSubscriptionPurchaseDirective');
require('../fhApp/currentUser/subscriptionStatus/subscriptionStatusDirective');

"use strict";

angular.module('app.pricing', [
    'app.pricing.pricingController',
    'app.purchase.purchaseForm.purchaseFormDirective',
    'app.purchase.purchaseForm.teamPurchaseFormDirective',
    'app.currentUser.subscriptionStatus.subscriptionStatusDirective'
])
    .config([
        '$stateProvider', 'PRODUCT',
        function ($stateProvider, product) {

            let priceTemplate = 'components/pricing/pricingView.html';
            if (product.Code != 'htv') {
                priceTemplate = 'assets/templates/' + product.Code + '/pricing/pricingView.html';
            }

            $stateProvider.state('app.pricing', {
                url: '/pricing',
                templateUrl: priceTemplate,
                controller: 'app.pricing.pricingController',
                title: 'Pricing',

                noSidebar: false,
                noTopControls: false,
            });
        }
    ]);



// WEBPACK FOOTER //
// ./app.v2/components/pricing/pricing.js